import React from "react";

import { ButtonGroup, Button, Accordion, Icon, NumberLabel } from "aible";

import { Tabs, Tab, OverlayTrigger, Popover } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUp,
  faExclamationTriangle,
  faArrowDown,
  faTimesCircle,
  faCheckCircle
} from "@fortawesome/free-solid-svg-icons";

import RunPlot from "containers/RunPlot/RunPlot";
import ModelTileContainer from "containers/Tiles/ModelTile";
import FeatureChartContainer from "containers/FeatureChart/FeatureChart";
import CurrentStateContainer from "containers/CurrentState/CurrentState";
import ChooseProcessLimitContainer from "containers/CreateWizard/Constraints/ChooseProcessLimit";
import AdvancedCostsContainer from "containers/CreateWizard/Costs/AdvancedCosts";
import MiniContainer from "containers/Results/Mini";

import SuccessResults from "components/CreateWizard/Success/SuccessResults";
import DeployStep from "components/CreateWizard/Success/DeployStep";

import AibleStep from "components/CreateWizard/AibleStep";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import ResultsGraph from "components/Results/ResultsGraph";
import ModelError from "components/Results/ModelError";

import ModelLoadingIndicator from "containers/Results/ModelLoadingIndicator";
import MiniDeploy from "containers/Deploy/MiniDeploy";

import TileHolder from "components/TileHolder/TileHolder";

import DeploymentItem from "containers/View/Item/DeploymentItem";

import { LineInput } from "components/Inputs/LineInput";

import { PANEL_MODES, GRAPH_TYPES } from "containers/Run/reducer";
import { calculateRatio } from "containers/Setup/reducer";

import { isEnabled } from "utils/featureFlags";

import styles from "./style.module.css";

export const SECTIONS = {
  OVERVIEW: "Overview",
  RESULTS: "Results",
  ROI_CHART: "ROI Chart",
  PREDICTION_DRIVERS: "Prediction Drivers",
  WHAT_IF: "What If"
};

export const MINI_BLUEPRINTS = {
  LARGESALES: {
    name: "Large Sales",
    id: "mini_blueprints_large_sales",
    truePositive: 10,
    falsePositive: -1
  },
  SALES: {
    name: "Sales",
    id: "mini_blueprints_sales",
    truePositive: 4,
    falsePositive: -1
  },
  MARKETING: {
    name: "Marketing",
    id: "mini_blueprints_marketing",
    truePositive: 2,
    falsePositive: -1
  },
  NONE: {
    name: "None",
    id: "mini_blueprints_none",
    truePositive: 1,
    falsePositive: -1
  },
  SERVICE: {
    name: "Service Resolution",
    id: "mini_blueprints_service_resolution",
    truePositive: 1,
    falsePositive: -2
  },
  PRODUCT: {
    name: "Product Defect",
    id: "mini_blueprints_product_defect",
    truePositive: 1,
    falsePositive: -4
  },
  LARGEPRODUCT: {
    name: "Large Product Defect",
    id: "mini_blueprints_large_product_defect",
    truePositive: 1,
    falsePositive: -10
  }
};

const customMiniBlueprint = {
  name: "Custom Ratio",
  id: "mini_blueprint_custom_ratio"
};

export default class AcademicResults extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      bMode: "SIMPLE",
      search: "",
      isDeploy: false,
      showAccuracyHelp: !this.props.selBid,
      showCapacityHelp: !this.props.selBid,
      showCurrentStateHelp: !this.props.selBid,
      customMiniBlueprint,
      showSearch: false
    };
  }

  showCostBenefits() {
    const { step, updateStep } = this.props;
    const { showAccuracyHelp } = this.state;
    if (showAccuracyHelp) {
      this.setState({ showAccuracyHelp: false });
    }
    if (step !== 0) {
      updateStep(0);
    }
  }

  showCapacity() {
    const { step, updateStep } = this.props;
    const { showCapacityHelp } = this.state;
    if (showCapacityHelp) {
      this.setState({ showCapacityHelp: false });
    }
    if (step !== 1) {
      updateStep(1);
    }
  }

  updateSelectedTab(key) {
    const { updateOption } = this.props;

    return updateOption("selectedTab", key);
  }
  renderContinuousHeader() {
    const { id, bestModel, models, currentState, processLimit, targeted, step, panelMode, selectedMiniBlueprint } =
      this.props;

    const numberFormatParams = {
      shortFormat: true,
      shortFormatMinValue: 0,
      precision: 1
    };

    const totalCost = Math.round(bestModel.metrics.overImpact + bestModel.metrics.underImpact);

    return (
      <div className={styles.oHeader}>
        <div className={styles.oItem}>
          <div className={styles.oItemTop}>{"Estimated Total Cost"}</div>
          <div className={styles.oItemMid}>
            <FontAwesomeIcon icon={faCheckCircle} className={styles.gIcon} />
            <NumberLabel params={numberFormatParams}>{totalCost}</NumberLabel>
          </div>
          {panelMode === PANEL_MODES.CLOSED && (
            <div className={styles.oItemBot}>{"Least of " + models.length + " models"}</div>
          )}
        </div>
        <div className={styles.oItem}>
          <div className={styles.oItemTop}>{"Costs & Benefits"}</div>
          {selectedMiniBlueprint ? (
            <div>
              <div className={styles.oItemMid}>
                <FontAwesomeIcon icon={faCheckCircle} className={styles.gIcon} />
                {Math.abs(selectedMiniBlueprint.falsePositive) + ":" + Math.abs(selectedMiniBlueprint.truePositive)}
              </div>
              {panelMode === PANEL_MODES.CLOSED && (
                <div className={styles.oItemBot}>{selectedMiniBlueprint.name + " cost ratio scenario selected"}</div>
              )}
            </div>
          ) : (
            <div>
              <div className={styles.oItemMid}>
                <FontAwesomeIcon icon={faTimesCircle} className={styles.xIcon} />
                {"Unknown"}
              </div>
              {panelMode === PANEL_MODES.CLOSED && <div className={styles.oItemBot}>{"No cost ratio set"}</div>}
            </div>
          )}
        </div>
        <div className={styles.oItem}>
          <div className={styles.oItemTop}>{""}</div>
          <div className={styles.oItemMid}>
            {/* <FontAwesomeIcon icon={faTimesCircle} className={styles.xIcon} /> */}
            {""}
          </div>
          {panelMode === PANEL_MODES.CLOSED && <div className={styles.oItemBot}>{""}</div>}
        </div>
      </div>
    );
  }

  renderHeader() {
    const {
      id,
      model,
      bestModel,
      models,
      currentState,
      processLimit,
      targeted,
      step,
      panelMode,
      conversionGain,
      conversionSaved,
      conversionCost,
      conversionMissed,
      isForceOptimized,
      selBid,
      selectedMiniBlueprint
    } = this.props;

    let metricData = {};
    let metricKey;
    if (!selBid || conversionGain <= Math.abs(conversionCost)) {
      metricData = {
        bestKey: "accuracy",
        bestName: "most accurate"
      };
    } else {
      metricData = {
        bestKey: "recall",
        bestName: "highest recall"
      };
    }
    let highestMetricModel = models && models[0];
    // let highestAccuracyModel = highestMetricModel;
    for (let currModel of models) {
      if (currModel.maxIteration[metricData.bestKey] > highestMetricModel.maxIteration[metricData.bestKey]) {
        highestMetricModel = currModel;
      }
      // if (currModel.maxIteration.accuracy > highestAccuracyModel.maxIteration.accuracy) {
      // 	highestAccuracyModel = currModel;
      // }
    }

    const showHighestAccuracy = model && model.id !== highestMetricModel.id;

    metricData.accuracy = highestMetricModel.maxIteration.accuracy;
    metricData.recall = highestMetricModel.maxIteration.recall;
    metricData.precision = highestMetricModel.maxIteration.precision;

    const higherImpact =
      highestMetricModel && showHighestAccuracy && bestModel
        ? (Math.abs((bestModel.checkMax - highestMetricModel.checkMax) / highestMetricModel.checkMax) * 100).toFixed(
            2
          ) + "%"
        : undefined;

    const numberFormatParams = {
      shortFormat: true,
      shortFormatMinValue: 0,
      precision: 1
    };

    const isSelectedRealisticBp = selectedMiniBlueprint && selectedMiniBlueprint.isAdvanced;
    let retGainRatio = conversionGain;
    let retCostRatio = conversionCost;
    if (isSelectedRealisticBp) {
      const retGain = conversionGain || 0;
      const retSaved = conversionSaved || 0;
      const retCost = conversionCost || 0;
      const retMissed = conversionMissed || 0;

      const trueGain = Math.abs(parseFloat(retGain) + parseFloat(retSaved));
      const trueCost = Math.abs(parseFloat(retCost) + parseFloat(retMissed));
      const denominator = Math.min(trueGain, trueCost) || 1;
      const gainRatio = trueGain / denominator;
      const costRatio = trueCost / denominator;

      retGainRatio = gainRatio >= 10 ? Math.round(gainRatio) : parseFloat(gainRatio.toFixed(2));
      retCostRatio = costRatio >= 10 ? Math.round(costRatio) : parseFloat(costRatio.toFixed(2));
    }

    return (
      <div className={styles.oHeader}>
        {bestModel && bestModel.maxIteration ? (
          <div className={styles.oItem}>
            <div className={styles.oItemWrap}>
              <HeaderMetric
                label={"Accuracy"}
                value={(model.maxIteration.accuracy * 100).toFixed(2) + "%"}
                isSmall={metricData.bestKey !== "accuracy"}
              />
              <HeaderMetric
                label={"Precision"}
                value={(model.maxIteration.precision * 100).toFixed(2) + "%"}
                isSmall={metricData.bestKey !== "precision"}
              />
              <HeaderMetric
                label={"Recall"}
                value={(model.maxIteration.recall * 100).toFixed(2) + "%"}
                isSmall={metricData.bestKey !== "recall"}
              />
              {/* <div className={styles.oItemCol}>
								<div className={styles.oItemTop + " " + (metricData.bestKey !== "accuracy" ? styles.small : "")}>{"Accuracy"}</div>
								<div className={styles.oItemMid + " " + (metricData.bestKey !== "accuracy" ? styles.small : "")}>
									{metricData.bestKey === "accuracty" ? <FontAwesomeIcon icon={faCheckCircle} className={styles.gIcon} /> : ""}
									{(metricData.accuracy * 100).toFixed(2) + "%"}
								</div>
							</div>
							<div className={styles.oItemCol}>
								<div className={styles.oItemTop + " " + styles.small}>{"Precision"}</div>
								<div className={styles.oItemMid + " " + styles.small}>
									{Math.round(bestModel.maxIteration.precision * 100).toFixed(2) + "%"}
								</div>
							</div>
							<div className={styles.oItemCol}>
								<div className={styles.oItemTop + " " + (metricData.bestKey !== "recall" ? styles.small : "")}>{"Recall"}</div>
								<div className={styles.oItemMid + " " + (metricData.bestKey !== "recall" ? styles.small : "")}>
									{metricData.bestKey === "recall" ? <FontAwesomeIcon icon={faCheckCircle} className={styles.gIcon} /> : ""}
									{(metricData.recall * 100).toFixed(2) + "%"}
								</div>
							</div> */}
            </div>
            {panelMode === PANEL_MODES.CLOSED ? (
              showHighestAccuracy ? (
                <div className={styles.oItemBot}>
                  {"Highest " +
                    metricData.bestKey +
                    " model was " +
                    (metricData[metricData.bestKey] * 100).toFixed(2) +
                    "%"}
                </div>
              ) : (
                <div className={styles.oItemBot}>{"Winner out of " + models.length + " models"}</div>
              )
            ) : (
              ""
            )}
          </div>
        ) : (
          <div className={styles.oItem}>
            <div className={styles.oItemTop}>{"Accuracy"}</div>
            <div className={styles.oItemMid}>
              <FontAwesomeIcon icon={faCheckCircle} className={styles.gIcon} />
              {"..."}
            </div>
            {panelMode === PANEL_MODES.CLOSED && <div className={styles.oItemBot}>{"Calculating"}</div>}
          </div>
        )}
        <div className={styles.oItem} onClick={() => this.showCostBenefits()}>
          <a className={styles.oItemTop}>{"Costs & Benefits"}</a>
          {selectedMiniBlueprint ? (
            <div>
              <div className={styles.oItemMid}>
                <FontAwesomeIcon icon={faCheckCircle} className={styles.gIcon} />
                {Math.abs(retCostRatio) + ":" + Math.abs(retGainRatio)}
              </div>
              {panelMode === PANEL_MODES.CLOSED && (
                <div className={styles.oItemBot}>{selectedMiniBlueprint.name + " scenario selected"}</div>
              )}
            </div>
          ) : (
            <div>
              <div className={styles.oItemMid}>
                <FontAwesomeIcon icon={faTimesCircle} className={styles.xIcon} />
                {"Unknown"}
              </div>
              {panelMode === PANEL_MODES.CLOSED && <div className={styles.oItemBot}>{"No cost ratio set"}</div>}
            </div>
          )}
        </div>
        {selectedMiniBlueprint ? (
          <div className={styles.oItem}>
            <div className={styles.oItemTop}>{"Estimated Impact"}</div>
            <div className={styles.oItemMid}>
              <FontAwesomeIcon icon={faCheckCircle} className={styles.gIcon} />
              <NumberLabel params={numberFormatParams}>{bestModel.checkMax}</NumberLabel>
            </div>
            {panelMode === PANEL_MODES.CLOSED && (
              <div className={styles.oItemBot}>
                {higherImpact !== undefined
                  ? higherImpact + " higher than " + metricData.bestName + " model"
                  : metricData.bestName.replace(/^\w/, (c) => c.toUpperCase()) + " model"}
              </div>
            )}
          </div>
        ) : (
          <div className={styles.oItem}>
            <div className={styles.oItemTop}>{"Impact"}</div>
            <div className={styles.oItemMid}>
              <FontAwesomeIcon icon={faTimesCircle} className={styles.xIcon} />
              {"Unknown"}
            </div>
            {panelMode === PANEL_MODES.CLOSED && <div className={styles.oItemBot}>{"Current state is unknown"}</div>}
          </div>
        )}
      </div>
    );
  }

  renderOverview() {
    const { id, isContinuous, selectedMiniBlueprint } = this.props;

    return (
      <div className={styles.chartHolder}>
        <div className={styles.chart} style={{ width: "100%" }}>
          {isContinuous ? this.renderContinuousHeader() : this.renderHeader()}
          <div style={{ height: "calc(100% - 120px)" }}>
            <RunPlot id={id} selectedMiniBlueprint={selectedMiniBlueprint} />
          </div>
        </div>
      </div>
    );
  }

  getImpactFromModel(model) {
    const { isContinuous, isQuickRun } = this.props;

    return model
      ? model.maxIteration && model.maxIteration.displayImpact
        ? isContinuous || isQuickRun
          ? Math.abs(Math.round(model.maxIteration.displayImpact))
          : Math.round(model.maxIteration.displayImpact)
        : isContinuous || isQuickRun
          ? Math.abs(Math.round(model.checkMax))
          : Math.round(model.checkMax)
      : undefined;
  }

  getUnconstrainedImpactFromModel(model) {
    const { isContinuous, isQuickRun } = this.props;

    return model
      ? model.maxIteration && model.maxIteration.roi
        ? isContinuous || isQuickRun
          ? Math.abs(Math.round(model.maxIteration.roi))
          : Math.round(model.maxIteration.roi)
        : isContinuous || isQuickRun
          ? Math.abs(Math.round(model.maxIteration.checkMax))
          : Math.round(model.checkMax)
      : undefined;
  }

  handleSectionSelect(section) {
    const { model, updateFieldSelect, fieldSelect } = this.props;

    if (section === SECTIONS.PREDICTION_DRIVERS) {
      if (fieldSelect === undefined && model && model.featureInfo && model.featureInfo.length > 0) {
        updateFieldSelect(model.featureInfo[0].label);
      }
    }

    return this.updateSelectedTab(section);
  }

  getBestUnconstrainedModel(models) {
    let bestModel = null;
    let bestUnconstrainedImpact = 0;

    for (let m in models) {
      let unconstrainedImpact = this.getUnconstrainedImpactFromModel(models[m]);
      if (unconstrainedImpact > bestUnconstrainedImpact) {
        bestUnconstrainedImpact = unconstrainedImpact;
        bestModel = models[m];
      }
    }
    return bestModel;
  }

  renderCapacity() {
    const { id } = this.props;

    const { showCapacityHelp } = this.state;

    return (
      <div>
        <Accordion
          style={{ padding: "20px" }}
          header={<div className={styles.h2}>{"Transaction Capacity"}</div>}
          show={showCapacityHelp}
          onClick={() => this.setState({ showCapacityHelp: !showCapacityHelp })}
        >
          <div className={styles.accordionText} style={{ marginTop: "40px" }}>
            {
              "If we consider cost benefit without considering capacity constraints we often end up in unrealistic situations. For example if the benefit is high relative to the cost then the model might get unrealistically aggressive. (process almost all transactions)"
            }
          </div>
          <div className={styles.accordionText}>
            {
              "So now we add in capacity constraints like how many sales transactions can you pursue with the number of salespeople you have in place. All of a sudden the most unrealistic models drop away because we cant process as many transactions as it was recommending. "
            }
          </div>
          <div className={styles.accordionText}>
            <strong>{"Set your capacity to find the highest performing model given your resources."}</strong>
          </div>
          <Button
            onClick={() => {
              GRAPH_TYPES.ACCURACY;
              this.setState({ showCapacityHelp: false });
            }}
            type={"primary"}
            style={{ margin: "30px 0px" }}
          >
            {"Add Transaction Capacity"}
          </Button>
        </Accordion>
        <div
          style={{
            width: "100%",
            maxHeight: showCapacityHelp ? "0px" : "unset",
            overflowY: "hidden"
          }}
        >
          <div style={{ padding: "0px 20px 20px 20px" }}>
            <div>
              {"Select the option below that best matches your business and" +
                " Aible will evaluate the models based on the typical cost ratio for that industry."}
            </div>
          </div>
          <div className={styles.bResults} style={{ margin: "0px" }}>
            <div style={{ width: "100%" }}>
              <ChooseProcessLimitContainer id={id} isMini />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderCurrentState() {
    const { id } = this.props;

    return (
      <div>
        <div style={{ padding: "20px", paddingBottom: "0px" }}>
          <div className={styles.miniBlueprintHeader}>{"Current State"}</div>
          <div>
            {"Select the option below that best matches your business and" +
              " Aible will evaluate the models based on the typical cost ratio for that industry."}
          </div>
        </div>
        <div className={styles.bResults}>
          <CurrentStateContainer id={id} isMini />
        </div>
      </div>
    );
  }

  renderTemplates() {
    const {
      updateConversionGain,
      updateConversionCost,
      updateConversionMissed,
      updateConversionSaved,
      updateCosts,
      conversionGain,
      conversionSaved,
      conversionCost,
      conversionMissed,
      updateSetup,
      incrementStep,
      models,
      miniModels,
      bestModel,
      updateProcessLimit,
      blueprints,
      panelMode,
      isBlueprintsLoading,
      updateIsForceOptimized,
      isForceOptimized,
      impactImprovement,
      selectedImpactComparison,
      id,
      isContinuous,
      selBid,
      updateSelectedBlueprintId,
      selectedMiniBlueprint,
      updateSelectedMiniBlueprint
    } = this.props;

    const { bMode, showAccuracyHelp, search, showSearch } = this.state;

    const prettyImpactImprov = impactImprovement ? Math.round(impactImprovement * 1000) / 10 : 0;
    const isSelectedRealisticBp = selectedMiniBlueprint && selectedMiniBlueprint.isAdvanced;

    const filteredBlueprints = search
      ? blueprints.filter((bp) => bp.name.toLowerCase().includes(search.toLowerCase()))
      : blueprints;

    let retGainRatio, retCostRatio;
    if (isSelectedRealisticBp) {
      const retGain = conversionGain || 0;
      const retSaved = conversionSaved || 0;
      const retCost = conversionCost || 0;
      const retMissed = conversionMissed || 0;

      const { costRatio, gainRatio } = calculateRatio({
        gain: retGain,
        cost: retCost,
        saved: retSaved,
        missed: retMissed
      });

      retGainRatio = gainRatio >= 10 ? Math.round(gainRatio) : parseFloat(gainRatio.toFixed(2));
      retCostRatio = costRatio >= 10 ? Math.round(costRatio) : parseFloat(costRatio.toFixed(2));
    }

    let costRatioTitle = "";
    if (isContinuous) {
      costRatioTitle = selBid === undefined ? "Lowest Error Model Found" : "Lowest Cost Model Found";
    } else {
      costRatioTitle = selBid === undefined ? "Most Accurate Model Found" : "Highest Impact Model Found";
    }

    return (
      <div className={styles.rightPanelWrapper}>
        <Accordion
          style={{ padding: "20px" }}
          header={<div className={styles.h2}>{costRatioTitle}</div>}
          show={showAccuracyHelp}
          onClick={() => this.setState({ showAccuracyHelp: !showAccuracyHelp })}
        >
          <div className={styles.accordionText} style={{ marginTop: "40px" }}>
            {"Aible has created " +
              (models ? models.length : 0) +
              " model" +
              (models && models.length === 1 ? "" : "s") +
              " and ranked them based on " +
              (isContinuous ? "their mean absolute error" : "accuracy") +
              "."}
          </div>
          <div className={styles.accordionText}>
            {
              "Without knowing anything about your use case a traditional AI assumes that all costs and benefits are equal. But in business, the benefit of a correct prediction is almost never equal to the cost of a wrong prediction."
            }
          </div>
          <div className={styles.accordionText}>
            <strong>
              {"Improve your " +
                (isContinuous ? "total cost" : "impact") +
                " by " +
                (prettyImpactImprov ? "up to " + prettyImpactImprov + "% " : "") +
                "adding the costs and benefits."}
            </strong>
          </div>
          <div className={styles.accordionButtons}>
            <Button type="secondary" style={{ marginRight: "auto" }} onClick={() => incrementStep()}>
              {"Evaluate Models"}
            </Button>
            <Button
              onClick={() => {
                this.setState({ showAccuracyHelp: false });
              }}
              type={"primary"}
              style={{ margin: "30px 0px" }}
            >
              {"Add Costs and Benefits"}
            </Button>
          </div>
        </Accordion>
        <div className={styles.miniBlueprintContentWrapper} style={{ maxHeight: showAccuracyHelp ? "0px" : "100%" }}>
          <div className={styles.bHeaderMenu}>
            <div className={styles.miniBlueprintHeader}>
              {"Add Costs and Benefits to " + (isContinuous ? "Improve Total Cost" : "Understand Business Impact")}
            </div>
            <div className={styles.miniBlueprintSubHeader + " " + (isSelectedRealisticBp ? styles.hide : "")}>
              {"Select a matching use case to add costs and benefits"}
            </div>
            <div
              className={styles.miniBlueprintSubHeader + " " + (isSelectedRealisticBp ? "" : styles.hide)}
              style={{ marginTop: "6px" }}
            >
              {retCostRatio + ":" + retGainRatio + " cost ratio"}
            </div>
            <div className={styles.miniBlueprintTabs + " " + (isSelectedRealisticBp ? styles.hide : "")}>
              <ButtonGroup>
                <Button active={bMode === "SIMPLE"} onClick={() => this.setState({ bMode: "SIMPLE" })}>
                  {"Simple Ratio"}
                </Button>
                <Button active={bMode === "REALISTIC"} onClick={() => this.setState({ bMode: "REALISTIC" })}>
                  {"Most Realistic"}
                </Button>
              </ButtonGroup>
              <Button type={"secondary"} active={showSearch} onClick={() => this.setState({ showSearch: !showSearch })}>
                <Icon type={"search"} size={15} />
              </Button>
            </div>
            <SearchBar
              onChange={(val) =>
                this.setState({
                  search: val && val.toLowerCase()
                })
              }
              show={showSearch}
            />
          </div>
          <div
            className={styles.bResultsWrapper}
            style={{
              maxHeight: isSelectedRealisticBp
                ? "calc(100% - 18px)"
                : showSearch
                  ? "calc(100% - 136px)"
                  : "calc(100% - 91px)"
            }}
          >
            {bMode === "SIMPLE" ? (
              <div className={styles.bResults}>
                {(search
                  ? Object.keys(MINI_BLUEPRINTS).filter((key) =>
                      search ? MINI_BLUEPRINTS[key].name.toLowerCase().includes(search) : true
                    )
                  : Object.keys(MINI_BLUEPRINTS)
                )
                  .map((k) => ({
                    key: k,
                    miniBlueprint: MINI_BLUEPRINTS[k]
                  }))
                  .map((wat, i) => {
                    const m = wat.miniBlueprint;
                    const blueprintKey = Math.abs(m.falsePositive) + ":" + Math.abs(m.truePositive);
                    const comparison = selectedImpactComparison ? selectedImpactComparison[blueprintKey] : undefined;

                    const nBestModel =
                      comparison && miniModels && miniModels[wat.key] && miniModels[wat.key].length > 0
                        ? miniModels[wat.key].filter((model) => model.id === comparison.bestModel)[0]
                        : undefined;

                    const oBestModel =
                      miniModels &&
                      miniModels[wat.key] &&
                      miniModels[wat.key].filter((model) => model.id === bestModel.id).length > 0
                        ? miniModels[wat.key].filter((model) => model.id === bestModel.id)[0]
                        : undefined;

                    let rawImprovement = oBestModel && nBestModel ? comparison.diff * 100 : undefined;

                    const improvement =
                      rawImprovement > 100
                        ? Math.round(rawImprovement)
                        : rawImprovement !== undefined
                          ? rawImprovement.toFixed(2)
                          : rawImprovement;

                    return (
                      <div
                        className={
                          styles.miniBlueprint + " " + (isForceOptimized && selBid === m.id ? styles.miniSelected : "")
                        }
                        key={i}
                        onClick={() => {
                          updateSelectedMiniBlueprint(m);
                          updateSelectedBlueprintId(m.id);

                          updateCosts({
                            conversionGain: m.truePositive,
                            conversionCost: m.falsePositive,
                            conversionSaved: -1 * m.falsePositive,
                            conversionMissed: -1 * m.truePositive
                          });

                          /*
													updateConversionGain(
														m.truePositive
													);
													updateConversionCost(
														m.falsePositive
													);
													updateConversionMissed(
														-1 * m.truePositive
													);
													updateConversionSaved(
														-1 * m.falsePositive
													);
													*/

                          !isForceOptimized && updateIsForceOptimized(true);
                        }}
                      >
                        <div className={styles.mName}>{m.name}</div>
                        <div className={styles.mSub}>
                          {Math.abs(m.falsePositive) + ":" + Math.abs(m.truePositive) + " cost ratio"}
                        </div>
                        {panelMode === PANEL_MODES.CLOSED &&
                        oBestModel &&
                        nBestModel &&
                        oBestModel.id === nBestModel.id ? (
                          <div className={styles.mDesc}>{nBestModel.label + " wins at this ratio"}</div>
                        ) : panelMode === PANEL_MODES.CLOSED && oBestModel && nBestModel && !isNaN(improvement) ? (
                          <div>
                            <div className={styles.mDesc}>{improvement + "% improvement with " + nBestModel.label}</div>
                          </div>
                        ) : (
                          <div />
                        )}
                      </div>
                    );
                  })}
                <CustomRatio
                  {...this.props}
                  selBid={selBid}
                  onClick={(selectedBp) => {
                    updateSelectedMiniBlueprint(selectedBp);
                    updateSelectedBlueprintId(selectedBp.id);
                  }}
                />
              </div>
            ) : (
              <div className={styles.bResults}>
                {isSelectedRealisticBp ? (
                  <div>
                    <AdvancedCostsContainer id={id} blueprintId={selBid} isAcademicResultsCard />
                  </div>
                ) : (
                  <React.Fragment>
                    {isBlueprintsLoading ? (
                      <LoadingIndicator />
                    ) : (
                      <React.Fragment>
                        {filteredBlueprints && filteredBlueprints.length
                          ? filteredBlueprints.map((b, i) => (
                              <BlueprintCard
                                key={i}
                                {...this.props}
                                selBid={selBid}
                                blueprint={b}
                                onClick={(val) => {
                                  updateSelectedBlueprintId(val.id);
                                  return updateSelectedMiniBlueprint(val);
                                }}
                                actionLabel={"Edit Assumptions"}
                                isAdvanced
                              />
                            ))
                          : "No blueprints found"}
                      </React.Fragment>
                    )}
                  </React.Fragment>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  renderMini() {
    const {
      initJob,
      isContinuous,
      updateStep,
      step,
      isForceOptimized,
      updateIsForceOptimized,
      updateSelectedMiniBlueprint,
      updateSelectedBlueprintId,
      selBid,
      resetImpacts,
      incrementStep
    } = this.props;
    const { showAccuracyHelp, showCapacityHelp, showCurrentStateHelp } = this.state;

    const showButtons =
      (step === 0 && !showAccuracyHelp) || (step === 1 && !showCapacityHelp) || (step >= 1 && !showCurrentStateHelp);

    return (
      <div className={styles.miniBlueprintHolder}>
        {step === 0 ? this.renderTemplates() : this.renderCapacity()}
        <div className={styles.miniFooter + " " + (showButtons ? "" : styles.hideBorder)}>
          {showButtons ? (
            <React.Fragment>
              <Button
                onClick={() => {
                  if (step > 0) {
                    return updateStep(step - 1);
                  } else {
                    if (selBid) {
                      updateSelectedMiniBlueprint(undefined);
                      updateSelectedBlueprintId(undefined);
                      resetImpacts();
                      updateIsForceOptimized(false);
                    }
                  }
                }}
                disabled={step === 0 && !isForceOptimized}
              >
                {"Previous"}
              </Button>
              {/* {(step === 2 || (step === 0 && isContinuous)) && (
								<Button type="primary" onClick={() => initJob()}>
									{"Retrain Models"}
								</Button>
							)} */}
              {/* {!isContinuous && step == 0 && (
								<Button
									onClick={() => {
										updateStep(step + 1);
									}}
									type={step === 0 ? "primary" : "default"}
									disabled={!isForceOptimized}
								>
									{step === 0
										? "Set Capacity"
										: step === 1
										? "Current State"
										: "Next Step"}
								</Button>
							)} */}
              {(step >= 0 || (step === 0 && isContinuous)) && (
                // <Button
                // 	type="primary"
                // 	onClick={() => {
                // 		this.setState({ isDeploy: true });
                // 		document
                // 			.getElementById("wizardStepScroll")
                // 			.scrollTo({ top: 99999, behavior: "smooth" });
                // 	}}
                // >
                // 	{"Get Predictions"}
                // </Button>
                <Button type="primary" onClick={() => incrementStep()}>
                  {"Evaluate Models"}
                </Button>
              )}
            </React.Fragment>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }

  render() {
    const {
      id,
      isNextStep,
      models,
      model,
      step,
      updateStep,
      deployment,
      hasDeployRecipe,
      cloudURL,
      options,
      handleRestfulDeploy,
      blueprintId,
      isEditBlueprint,
      updateIsNextStep,
      isError,
      errorMessages,
      panelMode
    } = this.props;

    const { isDeploy } = this.state;

    // Disable deployment for advanced models
    const isAdvancedModel = model && model.isAdvanced;

    if (isError) {
      return <ModelError errors={errorMessages} />;
    }

    if (models === undefined || model === undefined || models.filter((m) => m.id !== "Current State").length === 0) {
      return blueprintId === "new" || isEditBlueprint ? (
        <div className={styles.emptyMsg}>{"Success page will show here after models are trained"}</div>
      ) : (
        <div className={styles.emptyMsg}>
          <ModelLoadingIndicator id={id} />
        </div>
      );
    }

    const sectionKey = options && options["selectedTab"];

    return (
      <div>
        <div className={styles.results}>
          <div
            className={styles.resultsContent + " " + styles.academic}
            style={{
              height: "calc(100vh - 285px)",
              padding: "0px"
            }}
          >
            <div className={styles.aMiniHolder + (panelMode === PANEL_MODES.CLOSED ? "" : " " + styles.academicLeft)}>
              {this.renderMini()}
            </div>
            <div
              className={styles.aRightContent + (panelMode === PANEL_MODES.CLOSED ? "" : " " + styles.academicRight)}
            >
              {(true || sectionKey === SECTIONS.OVERVIEW || sectionKey === undefined) && this.renderOverview()}
            </div>
          </div>
        </div>
        <div className={styles.dHolder} style={isDeploy ? { minHeight: "300px" } : { height: "0px" }}>
          <TileHolder
            height={300}
            tiles={[
              ...(!hasDeployRecipe
                ? []
                : [
                    {
                      title: "Recipe Deploy",
                      closed: deployment ? (
                        <DeploymentItem
                          data={deployment}
                          deployRecipeId={deployRecipeId}
                          isTile
                          isSmall
                          noClick
                          style={{
                            height: "100%",
                            width: "100%",
                            marginTop: "25px"
                          }}
                        />
                      ) : (
                        <Button type="primary" onClick={() => handleRestfulDeploy(model.id)}>
                          {"Deploy as Writeback"}
                        </Button>
                      ),
                      hide: true,
                      isDisabled: isEnabled("deploy") !== true
                    }
                  ]),
              {
                title: "Deploy",
                closed: deployment ? (
                  <DeploymentItem
                    data={deployment}
                    isTile
                    isSmall
                    noClick
                    style={{
                      height: "100%",
                      width: "100%",
                      marginTop: "50px"
                    }}
                  />
                ) : (
                  <Button
                    type={hasDeployRecipe ? "secondary" : "primary"}
                    onClick={() => handleRestfulDeploy(model.id)}
                    disabled={isAdvancedModel}
                  >
                    {hasDeployRecipe
                      ? "Deploy as Lambda"
                      : isAdvancedModel
                        ? "Unable To Deploy Advanced Model"
                        : "Click to Deploy"}
                  </Button>
                ),
                hide: true,
                isDisabled: isEnabled("deploy") !== true
              },
              {
                title: "Score Data",
                closed: <Button type="secondary">{"Score Data"}</Button>,
                hide: true,
                open: <MiniDeploy id={id} modelId={model ? model.id : undefined} />,
                isDisabled: isEnabled("scoring") !== true
              },
              {
                title: "Publish",
                closed: (
                  <Button
                    type="secondary"
                    onClick={() => window.open(cloudURL, "_blank")}
                    disabled={cloudURL === undefined}
                  >
                    {"View Notebooks"}
                  </Button>
                ),
                hide: true,
                isDisabled: isEnabled("view-notebooks") !== true
              }
            ]}
          />
        </div>
      </div>
    );
  }
}

class HeaderMetric extends React.PureComponent {
  render() {
    const { label, value, isSmall } = this.props;
    return (
      <div className={styles.oItemCol}>
        <div className={styles.oItemTop + " " + (isSmall ? styles.small : "")}>{label}</div>
        <div className={styles.oItemMid + " " + (isSmall ? styles.small : "")}>
          {!isSmall ? <FontAwesomeIcon icon={faCheckCircle} className={styles.gIcon} /> : ""}
          {value}
        </div>
      </div>
    );
  }
}

class SearchBar extends React.PureComponent {
  render() {
    const { onChange, show } = this.props;
    return (
      <div className={styles.searchBar + " " + (show ? "" : styles.hide)}>
        <LineInput placeholder={"Search..."} onChange={(val) => onChange(val)} isMediumBox />
      </div>
    );
  }
}

class CustomRatio extends React.Component {
  state = {
    truePositive: 1,
    falsePositive: -1,
    trueNegative: 1,
    falseNegative: -1,
    isAdvanced: false,
    isEdit: false
  };

  handleUpdate(val) {
    this.setState(val, () => {
      this.handleSelect();
    });
  }

  renderSimple() {
    const {} = this.props;
    const { truePositive, falsePositive, isEdit } = this.state;
    return (
      <div className={styles.mRatioWrapper} onClick={(e) => isEdit && e.stopPropagation()}>
        <div className={styles.mRatio}>
          {isEdit ? (
            <span>
              <LineInput
                isMediumBox
                placeholder={"Cost"}
                defaultValue={Math.abs(falsePositive)}
                onChange={(val) =>
                  this.handleUpdate({
                    falsePositive: -1 * val
                  })
                }
              />
            </span>
          ) : (
            <span>{Math.abs(falsePositive)}</span>
          )}
        </div>
        <div style={{ marginRight: isEdit ? "6px" : "0px" }}>{":"}</div>
        <div className={styles.mRatio}>
          {isEdit ? (
            <span>
              <LineInput
                isMediumBox
                placeholder={"Benefit"}
                defaultValue={Math.abs(truePositive)}
                onChange={(val) => this.handleUpdate({ truePositive: val })}
              />
            </span>
          ) : (
            <span>{Math.abs(truePositive)}</span>
          )}
        </div>
        <div>&nbsp;{"cost ratio"}</div>
      </div>
    );
  }

  renderAdvanced() {
    const {} = this.props;
    const { truePositive, falsePositive, trueNegative, falseNegative, isEdit } = this.state;
    return (
      <div
        className={styles.mRatioWrapper + " " + styles.mRatioAdvanced}
        onClick={(e) => isEdit && e.stopPropagation()}
      >
        <div className={styles.mRatioHeader}>Impacts</div>
        <div className={styles.mRatio + " " + styles.mRatioAdvanced}>
          <span>{"Correctly Pursued: "}</span>
          {isEdit ? (
            <span>
              <LineInput
                isMediumBox
                placeholder={"True Positive"}
                defaultValue={truePositive}
                onChange={(val) => this.handleUpdate({ truePositive: val })}
              />
            </span>
          ) : (
            <span>{truePositive}</span>
          )}
        </div>
        <div className={styles.mRatio + " " + styles.mRatioAdvanced}>
          <span>{"Incorrectly Pursued: "}</span>
          {isEdit ? (
            <span>
              <LineInput
                isMediumBox
                placeholder={"False Positive"}
                defaultValue={falsePositive}
                onChange={(val) => this.handleUpdate({ falsePositive: val })}
              />
            </span>
          ) : (
            <span>{falsePositive}</span>
          )}
        </div>
        <div className={styles.mRatio + " " + styles.mRatioAdvanced}>
          <span>{"Correctly Ignored: "}</span>
          {isEdit ? (
            <span>
              <LineInput
                isMediumBox
                placeholder={"True Negative"}
                defaultValue={trueNegative}
                onChange={(val) => this.handleUpdate({ trueNegative: val })}
              />
            </span>
          ) : (
            <span>{trueNegative}</span>
          )}
        </div>
        <div className={styles.mRatio + " " + styles.mRatioAdvanced}>
          <span>{"Incorrectly Ignored: "}</span>
          {isEdit ? (
            <span>
              <LineInput
                isMediumBox
                placeholder={"False Negative"}
                defaultValue={falseNegative}
                onChange={(val) => this.handleUpdate({ falseNegative: val })}
              />
            </span>
          ) : (
            <span>{falseNegative}</span>
          )}
        </div>
      </div>
    );
  }

  handleSelect(skipEditUpdate = false) {
    const {
      onClick,
      updateConversionGain,
      updateConversionCost,
      updateConversionMissed,
      updateConversionSaved,
      updateCosts,
      isForceOptimized,
      updateIsForceOptimized
    } = this.props;
    const { truePositive, falsePositive, trueNegative, falseNegative, isEdit } = this.state;

    onClick &&
      onClick({
        ...customMiniBlueprint,
        truePositive,
        falsePositive,
        trueNegative,
        falseNegative
      });

    updateCosts({
      conversionGain: truePositive,
      conversionCost: falsePositive,
      conversionSaved: trueNegative,
      conversionMissed: falseNegative
    });

    /*
		updateConversionGain(truePositive);
		updateConversionCost(falsePositive);
		updateConversionSaved(trueNegative);
		updateConversionMissed(falseNegative);
		*/

    !isForceOptimized && updateIsForceOptimized(true);
    if (!skipEditUpdate && !isEdit) {
      this.setState({
        isEdit: true
      });
    }
  }

  render() {
    const {
      onClick,
      updateConversionGain,
      updateConversionCost,
      updateConversionMissed,
      updateConversionSaved,
      isForceOptimized,
      updateIsForceOptimized,
      selBid
    } = this.props;

    const { truePositive, falsePositive, trueNegative, falseNegative, isAdvanced, isEdit } = this.state;

    return (
      <div
        className={
          styles.miniBlueprint +
          " " +
          (isForceOptimized && selBid === customMiniBlueprint.id ? styles.miniSelected : "")
        }
        onClick={() => this.handleSelect()}
      >
        <div className={styles.mName}>{customMiniBlueprint.name}</div>
        <div className={styles.mSub}>{isAdvanced ? this.renderAdvanced() : this.renderSimple()}</div>
        <div className={styles.mAction}>
          {false && isEdit ? (
            <a
              onClick={(e) => {
                this.setState({
                  isAdvanced: !isAdvanced
                });
              }}
            >
              {isAdvanced ? "Simple" : "Advanced"}
            </a>
          ) : (
            ""
          )}
          <a
            onClick={(e) => {
              this.handleSelect(true);
              return this.setState({
                isEdit: !isEdit
              });
            }}
          >
            {(isEdit ? "Save" : "Edit") + " " + (isAdvanced ? "Impacts" : "Ratio")}
          </a>
        </div>
      </div>
    );
  }
}

class BlueprintCard extends React.Component {
  state = {
    show: false
  };

  render() {
    const {
      blueprint,
      updateConversionGain,
      updateConversionCost,
      updateConversionMissed,
      updateConversionSaved,
      updateCosts,
      setCustomValues,
      updateProcessLimit,
      updateIsForceOptimized,
      isForceOptimized,
      onClick,
      conversionGain,
      conversionSaved,
      conversionCost,
      conversionMissed,
      selBid,
      actionLabel,
      isAdvanced
    } = this.props;

    const isSelected = selBid === blueprint.id;

    let retGain, retSaved, retCost, retMissed;
    if (isSelected) {
      retGain = conversionGain || 0;
      retSaved = conversionSaved || 0;
      retCost = conversionCost || 0;
      retMissed = conversionMissed || 0;
    } else {
      retGain = blueprint.wizard.setup.conversionGain || 0;
      retSaved = blueprint.wizard.setup.conversionSaved || 0;
      retCost = blueprint.wizard.setup.conversionCost || 0;
      retMissed = blueprint.wizard.setup.conversionMissed || 0;
    }

    const { costRatio, gainRatio } = calculateRatio({
      gain: retGain,
      cost: retCost,
      saved: retSaved,
      missed: retMissed
    });

    const retGainRatio = gainRatio >= 10 ? Math.round(gainRatio) : parseFloat(gainRatio.toFixed(2));
    const retCostRatio = costRatio >= 10 ? Math.round(costRatio) : parseFloat(costRatio.toFixed(2));

    return (
      <div
        className={styles.miniBlueprint + " " + (isForceOptimized && isSelected ? styles.miniSelected : "")}
        onClick={() => {
          onClick({
            truePositive: blueprint.wizard.setup.conversionGain,
            falsePositive: blueprint.wizard.setup.conversionCost,
            name: blueprint.name,
            isAdvanced: true,
            id: blueprint.id
          });

          updateCosts({
            conversionGain: blueprint.wizard.setup.conversionGain,
            conversionCost: blueprint.wizard.setup.conversionCost,
            conversionMissed: blueprint.wizard.setup.conversionMissed,
            conversionSaved: blueprint.wizard.setup.conversionSaved
          });

          /*
					updateConversionGain(blueprint.wizard.setup.conversionGain);
					updateConversionCost(blueprint.wizard.setup.conversionCost);
					updateConversionMissed(
						blueprint.wizard.setup.conversionMissed
					);
					updateConversionSaved(
						blueprint.wizard.setup.conversionSaved
					);
					*/

          setCustomValues(blueprint.wizard.setup.customValues);
          !isForceOptimized && updateIsForceOptimized(true);
        }}
      >
        <div className={styles.mName}>{blueprint.name}</div>
        <div className={styles.mSub}>{isAdvanced ? "" : retCostRatio + ":" + retGainRatio + " cost ratio"}</div>
        <div className={styles.mAction}>
          <a> {actionLabel ? actionLabel : "Edit Ratio"} </a>
        </div>
      </div>
    );
  }
}
